// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactCard Styles - Single Card Component */

.scl--web-component-contact-card-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 394px;
  height: 100%;
  position: relative;
  flex: 1;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
}

.scl--web-component-contact-card-inner {
  position: relative;
  width: 100%;
  min-height: 370px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.scl--web-component-contact-rectangle-3 {
  position: absolute;
  left: 3.23%;
  right: 90.52%;
  top: -5.41%;
  bottom: 100%;
  border: 1px solid #000000;
  border-radius: 2px;
}

.scl--web-component-contact-rectangle-2 {
  position: absolute;
  left: 4.96%;
  right: 92.24%;
  top: -7.03%;
  bottom: 105.41%;
  border: 1px solid #000000;
}

.scl--web-component-contact-card-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 0px 60px 0px;
  gap: 65px;
  position: relative;
  width: 100%;
  max-width: 433px;
  min-height: 287px;
  height: 100%;
  flex: 1;
}

.scl--web-component-contact-text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 70px;
  width: 100%;
  min-height: 182px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-contact-card-title {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 100%;
  text-transform: capitalize;
  margin: 0;
  background: linear-gradient(260.66deg, #FFFFFF 80.26%, #C9C9C9 112.45%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-contact-card-description {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 16px;
  line-height: 150%;
  color: #7D8187;
  margin: 0;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-contact-styled-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 6px;
  min-width: 140px;
  height: 40px;
  border-radius: 20px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: auto;
}

.scl--web-component-contact-styled-button span:first-child {
  height: 20px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/contact/css/contactCard.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;EACT,uEAAuE;EACvE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd","sourcesContent":["/* ContactCard Styles - Single Card Component */\n\n.scl--web-component-contact-card-container {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 394px;\n  height: 100%;\n  position: relative;\n  flex: 1;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.scl--web-component-contact-card-inner {\n  position: relative;\n  width: 100%;\n  min-height: 370px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.scl--web-component-contact-rectangle-3 {\n  position: absolute;\n  left: 3.23%;\n  right: 90.52%;\n  top: -5.41%;\n  bottom: 100%;\n  border: 1px solid #000000;\n  border-radius: 2px;\n}\n\n.scl--web-component-contact-rectangle-2 {\n  position: absolute;\n  left: 4.96%;\n  right: 92.24%;\n  top: -7.03%;\n  bottom: 105.41%;\n  border: 1px solid #000000;\n}\n\n.scl--web-component-contact-card-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px 0px 60px 0px;\n  gap: 65px;\n  position: relative;\n  width: 100%;\n  max-width: 433px;\n  min-height: 287px;\n  height: 100%;\n  flex: 1;\n}\n\n.scl--web-component-contact-text-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 70px;\n  width: 100%;\n  min-height: 182px;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-contact-card-title {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 30px;\n  line-height: 100%;\n  text-transform: capitalize;\n  margin: 0;\n  background: linear-gradient(260.66deg, #FFFFFF 80.26%, #C9C9C9 112.45%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-contact-card-description {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 16px;\n  line-height: 150%;\n  color: #7D8187;\n  margin: 0;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-contact-styled-button {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 6px;\n  min-width: 140px;\n  height: 40px;\n  border-radius: 20px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  margin-top: auto;\n}\n\n.scl--web-component-contact-styled-button span:first-child {\n  height: 20px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
